import React from 'react';
import ReactDom from 'react-dom';
import { Fabric } from 'office-ui-fabric-react';
import { Suspense } from 'react';

import App from './App';
import './StyleSheets/Index.scss';

ReactDom.render(
  <React.StrictMode>
    <Fabric>
      <Suspense fallback="...is loading">
        <App />
      </Suspense>
    </Fabric>
  </React.StrictMode>,
  document.getElementById('root'),
);
